import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  comment: {
    read: ["all"],
    create: ["all"],
    update: ["all"],
    delete: ["master", "administrator", "program_manager"],
    config: ["master", "administrator", "program_manager"]
  },
  tag: {
    read: ["all"],
    create: ["all"],
    update: ["master", "program_manager"],
    delete: ["master", "program_manager"],
    config: ["master", "program_manager"]
  },
  goal: {
    read: ["all"],
    create: ["all"],
    update: ["master", "program_manager"],
    delete: ["master", "program_manager"],
    config: ["master", "program_manager"]
  },
  account: {
    read: ["all"],
    create: ["master"],
    update: ["master"],
    delete: ["master"],
    config: ["master"]
  }
};
